import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'utcToLocal',
    standalone: false
})
export class UtcToLocalPipe implements PipeTransform {

  transform(value: any): any {
    if (!value) {
      return null;
    }
    var newDate = new Date(value);
    newDate.setMinutes(newDate.getMinutes() - newDate.getTimezoneOffset());
    return newDate;
  }

}